import script from "./PagePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./PagePreview.vue?vue&type=script&setup=true&lang=js"

import "./PagePreview.vue?vue&type=style&index=0&id=ce3633fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce3633fa"]])

export default __exports__